"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSessionToken = exports.subscribeToLogoutEvent = exports.setUserNotAuthenticated = exports.sendTwoFactorAuthCode = exports.require2FA = exports.redirectFromLogin = exports.mark2FAReconnection = exports.logout = exports.login = exports.enforceEnable2FA = exports.authSuccess = exports.authError = exports.FORCED_LOGOUT = exports.ENABLE_2FA_REQUIRED = exports.AUTH_SUCCESS = exports.AUTH_REDIRECT = exports.AUTH_NONE = exports.AUTH_ERROR = exports.AUTH_2FA_REQUIRED = void 0;
var _apex = _interopRequireDefault(require("../../apex"));
var _config = _interopRequireDefault(require("../../config"));
var _reduxForm = require("redux-form");
var _LogoutEventSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/LogoutEventSubscriptionService"));
var _userActions = require("./userActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var AUTH_SUCCESS = exports.AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = exports.AUTH_ERROR = 'AUTH_ERROR';
var AUTH_NONE = exports.AUTH_NONE = 'AUTH_NONE';
var AUTH_REDIRECT = exports.AUTH_REDIRECT = 'AUTH_REDIRECT';
var AUTH_2FA_REQUIRED = exports.AUTH_2FA_REQUIRED = 'AUTH_2FA_REQUIRED';
var FORCED_LOGOUT = exports.FORCED_LOGOUT = 'FORCED_LOGOUT';
var ENABLE_2FA_REQUIRED = exports.ENABLE_2FA_REQUIRED = 'ENABLE_2FA_REQUIRED';

// Store credentials in memory during 2FA flow
// This allows re-authentication if connection is lost during 2FA
var pending2FACredentials = null;

// Track if connection was lost during 2FA flow
var had2FAReconnection = false;

// Function to mark that reconnection happened during 2FA
// Called by middleware when connection reopens
var mark2FAReconnection = exports.mark2FAReconnection = function mark2FAReconnection() {
  if (pending2FACredentials) {
    had2FAReconnection = true;
  }
};
var login = exports.login = function login(creds) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var auth;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _apex["default"].connection.WebAuthenticateUser(creds);
          case 1:
            auth = _context.v;
            if (!(auth.Authenticated && auth.Requires2FA)) {
              _context.n = 2;
              break;
            }
            // Store credentials for potential re-authentication during 2FA
            pending2FACredentials = _objectSpread({}, creds);
            had2FAReconnection = false; // Reset the reconnection flag
            return _context.a(2, dispatch(require2FA(auth)));
          case 2:
            if (!auth.Authenticated) {
              _context.n = 4;
              break;
            }
            // Clear any pending credentials on successful auth
            pending2FACredentials = null;
            had2FAReconnection = false;
            if (!auth.EnforceEnable2FA) {
              _context.n = 3;
              break;
            }
            return _context.a(2, dispatch(forceEnable2FA(creds)));
          case 3:
            return _context.a(2, dispatch(authSuccess(auth)));
          case 4:
            // Clear credentials on failed auth
            pending2FACredentials = null;
            had2FAReconnection = false;
            dispatch((0, _reduxForm.change)('login', 'password', ''));
            dispatch((0, _reduxForm.untouch)('login', 'password'));
            return _context.a(2, dispatch(authError(auth)));
          case 5:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var forceEnable2FA = function forceEnable2FA(creds) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch((0, _userActions.getGoogleQrCode)());
            return _context2.a(2, dispatch(enforceEnable2FA(creds)));
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var enforceEnable2FA = exports.enforceEnable2FA = function enforceEnable2FA(creds) {
  return {
    type: ENABLE_2FA_REQUIRED,
    payload: {
      creds: creds,
      enable2FARequired: true
    }
  };
};
var logout = exports.logout = function logout() {
  return function (dispatch, getState) {
    // Clear 2FA credentials on logout
    pending2FACredentials = null;
    had2FAReconnection = false;
    var wasAuthenticatedBefore = getState().auth.isAuthenticated;
    var action = setUserNotAuthenticated(wasAuthenticatedBefore);
    _apex["default"].connection.RPCPromise('LogOut', {}).then(function () {
      console.log('logged out');
    })["catch"](function (err) {
      console.warn(err);
    });

    // Clear all user-specific data from localStorage
    localStorage.removeItem('tradingServer');
    localStorage.removeItem('fmsGateway');
    localStorage.removeItem('selectedAccountId');
    localStorage.removeItem('selectedPositionId');
    localStorage.removeItem('selectedInstrumentId');
    localStorage.removeItem('selectedFuturesInstrumentId');
    dispatch(action);
  };
};
var authSuccess = exports.authSuccess = function authSuccess(payload) {
  // Clear stored credentials on successful authentication
  pending2FACredentials = null;
  had2FAReconnection = false;
  return {
    type: AUTH_SUCCESS,
    payload: {
      isAuthenticated: payload.Authenticated,
      userId: payload.UserId,
      token: payload.SessionToken,
      pending: false,
      is2FARequired: false
    }
  };
};
var authError = exports.authError = function authError(payload) {
  return {
    type: AUTH_ERROR,
    payload: {
      isAuthenticated: payload.Authenticated,
      errorMsg: payload.errormsg,
      pending: false
    }
  };
};
var subscribeToLogoutEvent = exports.subscribeToLogoutEvent = function subscribeToLogoutEvent() {
  return function (dispatch) {
    _LogoutEventSubscriptionService["default"].subscribe(function (message) {
      dispatch(forcedLogOut(message));
    });
  };
};
var forcedLogOut = function forcedLogOut(message) {
  // Clear 2FA credentials on forced logout
  pending2FACredentials = null;
  had2FAReconnection = false;
  return {
    type: FORCED_LOGOUT,
    payload: message
  };
};
var require2FA = exports.require2FA = function require2FA(payload) {
  return {
    type: AUTH_2FA_REQUIRED,
    payload: {
      userId: payload.UserId,
      is2FARequired: true
    }
  };
};
var setUserNotAuthenticated = exports.setUserNotAuthenticated = function setUserNotAuthenticated() {
  var wasAuthenticatedBefore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: AUTH_NONE,
    payload: {
      isAuthenticated: false,
      userId: null,
      token: null,
      pending: false,
      wasAuthenticatedBefore: wasAuthenticatedBefore
    }
  };
};
var redirectFromLogin = exports.redirectFromLogin = function redirectFromLogin(location) {
  return {
    type: AUTH_REDIRECT,
    payload: {
      shouldRedirect: !!location,
      location: location
    }
  };
};
var validateSessionToken = exports.validateSessionToken = function validateSessionToken(token) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var authTimeout, timeoutID, auth;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            authTimeout = _config["default"].global.authTimeout;
            timeoutID = authTimeout ? setTimeout(function () {
              localStorage.removeItem('token');
              window.location.reload();
            }, authTimeout) : 0;
            _context3.n = 1;
            return _apex["default"].connection.WebAuthenticateUser({
              SessionToken: token
            });
          case 1:
            auth = _context3.v;
            clearTimeout(timeoutID);
            if (!auth.Authenticated) {
              _context3.n = 3;
              break;
            }
            _context3.n = 2;
            return dispatch(authSuccess(auth));
          case 2:
            return _context3.a(2, auth);
          case 3:
            _context3.n = 4;
            return dispatch(logout());
          case 4:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var sendTwoFactorAuthCode = exports.sendTwoFactorAuthCode = function sendTwoFactorAuthCode(Code) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, _getState) {
      var auth, reauth, _auth$errormsg, _reauth, _t;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            if (!(pending2FACredentials && had2FAReconnection)) {
              _context4.n = 4;
              break;
            }
            _context4.n = 1;
            return _apex["default"].connection.WebAuthenticateUser(pending2FACredentials);
          case 1:
            reauth = _context4.v;
            if (!(!reauth.Authenticated || !reauth.Requires2FA)) {
              _context4.n = 2;
              break;
            }
            console.error('[2FA] Re-authentication failed or does not require 2FA');
            pending2FACredentials = null;
            return _context4.a(2, dispatch(authError({
              Authenticated: false,
              errormsg: 'Session expired. Please try logging in again.'
            })));
          case 2:
            _context4.n = 3;
            return _apex["default"].connection.Authenticate2FA({
              Code: Code
            });
          case 3:
            auth = _context4.v;
            _context4.n = 9;
            break;
          case 4:
            _context4.n = 5;
            return _apex["default"].connection.Authenticate2FA({
              Code: Code
            });
          case 5:
            auth = _context4.v;
            if (!((auth.o === 'Endpoint Not Found' || (_auth$errormsg = auth.errormsg) !== null && _auth$errormsg !== void 0 && _auth$errormsg.includes('Endpoint Not Found')) && pending2FACredentials)) {
              _context4.n = 9;
              break;
            }
            _context4.n = 6;
            return _apex["default"].connection.WebAuthenticateUser(pending2FACredentials);
          case 6:
            _reauth = _context4.v;
            if (!(!_reauth.Authenticated || !_reauth.Requires2FA)) {
              _context4.n = 7;
              break;
            }
            console.error('[2FA] Re-authentication failed');
            pending2FACredentials = null;
            return _context4.a(2, dispatch(authError({
              Authenticated: false,
              errormsg: 'Session expired. Please try logging in again.'
            })));
          case 7:
            _context4.n = 8;
            return _apex["default"].connection.Authenticate2FA({
              Code: Code
            });
          case 8:
            auth = _context4.v;
          case 9:
            if (!auth.Authenticated) {
              _context4.n = 10;
              break;
            }
            return _context4.a(2, dispatch(authSuccess(auth)));
          case 10:
            return _context4.a(2, dispatch(authError(auth)));
          case 11:
            _context4.n = 13;
            break;
          case 12:
            _context4.p = 12;
            _t = _context4.v;
            console.error('[2FA] Error during 2FA authentication:', _t);
            return _context4.a(2, dispatch(authError({
              Authenticated: false,
              errormsg: 'Authentication failed. Please try again.'
            })));
          case 13:
            return _context4.a(2);
        }
      }, _callee4, null, [[0, 12]]);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};